import { FC } from "react"

import { Box, useTheme } from "@mui/material"
import TransactionIcon from "components/common/icon/transactionIcon"
import { useIsBreakpointUp } from "hooks/breakpoint"
import { PrimaryTile } from "styles/common/tile"
import { TransactionType } from "ts/types/Transaction"

import ContentTile from "./contentTile"

interface IProps {
  title: string
  amount: number | string
  variant?: TransactionType
  selected?: boolean
  onClick?: () => void
  // > 0 leaves room below the content for the quantity stepper.
  quantity?: number
}

const Tile: FC<IProps> = ({
  title,
  amount,
  variant = "bonus",
  selected = false,
  onClick,
  quantity = 0,
}) => {
  const theme = useTheme()
  const isTablet = useIsBreakpointUp("tablet")

  return (
    <PrimaryTile
      onClick={onClick}
      role="button"
      tabIndex={0}
      aria-pressed={selected}
      aria-label={`${title}, ${amount}`}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault()
          onClick?.()
        }
      }}
      position="relative"
      p="16px"
      sx={[
        {
          cursor: "pointer",
          ...(quantity > 0 && { pb: "52px" }),
          "&:hover": {
            background: theme.palette.mockup.primary95,
            borderColor: theme.palette.mockup.primary95,
          },
        },
        selected && {
          background: theme.palette.primary.light,
          borderColor: theme.palette.primary.main,
        },
      ]}
    >
      <Box display="flex" gap="8px" width="100%" alignItems="center">
        {isTablet && <TransactionIcon variant={variant} />}
        <ContentTile title={title} amount={amount} />
      </Box>
    </PrimaryTile>
  )
}

export default Tile
